import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { useSettings } from "./settingContext";

const OrdersContext = createContext();

export const OrdersProvider = ({ children }) => {

    const [ordersData, setOrdersData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [wishItem, setWishItem] = useState(null);

    const { user } = useSettings();
    const userId = user?.id;

    const getOrders = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${process.env.REACT_APP_API_URL}api/listing-order?user_id=${userId}`);
            const apiOrders = res.data?.data?.data?.order || [];
            const mappedOrders = apiOrders.map((order) => ({
                key: order.id,
                orderId: order.order_number,
                customer: `${order.billing_first_name || ""} ${order.billing_last_name || ""}`,
                date: new Date(order.created_at).toLocaleDateString(),
                status: order.order_status,
                total: `$${order.total}`,
            }));
            setOrdersData(mappedOrders);
        } catch (error) {
            console.error("Orders Listing Fetching Content:", error);
        } finally {
            setLoading(false);
        }
    };

    const getWishItem = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}api/listing-wishlist?user_id=${userId}`
            );
            setWishItem(res.data.data || []);
        } catch (error) {
            console.log("Wishlist Listing Fetching", error);
            setWishItem([]);
        }
    };

    return (
        <OrdersContext.Provider value={{ getOrders, loading, ordersData, wishItem, setWishItem, getWishItem }}>
            {children}
        </OrdersContext.Provider>
    )
}

export const useOrders = () => useContext(OrdersContext);